import { Heading, Text, VStack } from "@chakra-ui/react"

import stackMatsnetHeaderLogo from "#/assets/stack-matsnet-header-logo.svg"
import CurrencySymbol from "#/shared/components/CurrencySymbol"
import { bigIntToHumanReadableFormat, networkUtils } from "#/shared/utils"
import DepositCarouselModalHeader from "#/ui-old/DepositCarousel/DepositCarouselModalHeader"

type StackMatsnetBtcModalHeaderProps = {
  totalMats: number
}

export default function StackMatsnetBtcModalHeader({
  totalMats,
}: StackMatsnetBtcModalHeaderProps) {
  return (
    <DepositCarouselModalHeader
      imageSrc={stackMatsnetHeaderLogo}
      imageProps={{
        position: "absolute",
        right: 0,
        zIndex: 1,
      }}
      bg="primary.black.100"
      color="white"
    >
      <VStack alignItems="flex-start" gap="12px">
        <Heading variant="h3" fontSize="32px" lineHeight="40px" zIndex={10}>
          Stack {networkUtils.getMezoNetworkLabel()} sats
        </Heading>
        <Text variant="label" zIndex={10} color="primary.white.50">
          Max {bigIntToHumanReadableFormat(BigInt(totalMats) * 10n, 8, 8)}{" "}
          <CurrencySymbol token="mBTC" />
        </Text>
      </VStack>
    </DepositCarouselModalHeader>
  )
}
